import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";

type TagDesignType = "information" | "custom";

export const Tag = ({
  tag,
  type,
  tagDesignCustomData,
}: {
  tag: string;
  type: TagDesignType;
  tagDesignCustomData?: string;
}) => {
  return (
    <article
      className={cn(
        "flex items-center justify-center rounded-md text-xs px-1 py-2.5 text-white font-bold w-fit",
        type === "custom" ? tagDesignCustomData : "bg-information",
      )}
    >
      <p className="leading-0">{tag}</p>
    </article>
  );
};

export const NewTag = ({ tag }: { tag?: string }) => {
  const { t } = useTranslation("common");
  return (
    <article
      className={cn(
        "flex items-center justify-center rounded-md text-xs px-1 py-2.5 text-white bg-information font-bold whitespace-nowrap",
      )}
    >
      <p className="leading-0">{tag ?? t("tags.new")}</p>
    </article>
  );
};
